import type { BucketSelection, FacetFilter, SubFacetsQueryConfig } from "../types";
import { fetchFacets, OVERLAY_MAX_RESULT } from "./fetchFacets";

export const SUB_FACETS_STALE_TIME = 5 * 60 * 1000;

export const subFacetsQueryKey = (
    index: string,
    locks: BucketSelection[],
    extraFilters: FacetFilter[] = [],
) =>
    [
        "overview-subfacets",
        index,
        ...locks.flatMap((lock) => [lock.field, lock.value]),
        ...extraFilters.flatMap((filter) => [filter.key, ...filter.value]),
    ] as const;

export const locksToFilters = (locks: BucketSelection[]): FacetFilter[] => {
    const grouped = new Map<string, string[]>();
    locks.forEach((lock) => {
        const values = grouped.get(lock.field) ?? [];
        values.push(lock.value);
        grouped.set(lock.field, values);
    });
    return Array.from(grouped, ([key, value]) => ({ key, value }));
};

export const subFacetsQueryOptions = ({
    instance,
    index,
    locks,
    extraFilters = [],
}: SubFacetsQueryConfig) => ({
    queryKey: subFacetsQueryKey(index, locks, extraFilters),
    staleTime: SUB_FACETS_STALE_TIME,
    queryFn: () =>
        fetchFacets({
            instance,
            index,
            filters: [...locksToFilters(locks), ...extraFilters],
            maxResult: OVERLAY_MAX_RESULT,
        }),
});
